import React, { useState, useEffect } from 'react';
import BlockPayAddress from "../../BlockAddress/components/BlockPayAddress";
import { setSelectedDeliverorPayAddressData } from '../../../../../redux/checkoutredux/actions/checkoutactions/checkoutActions';

const BlockBilling = ({ store }) => {
  const [accordion1Checked, setAccordion1Checked] = useState(false);
  const [accordion2Checked, setAccordion2Checked] = useState(false);

  const deliverorpayaddress = store.getState().selectedorderdata.deliverorpayaddressdata;
  console.log("Rechnung oder Lieferadresse: ", deliverorpayaddress);

  useEffect(() => {
    if (deliverorpayaddress === 'delivery') {
      setAccordion1Checked(true);
      setAccordion2Checked(false);
    } else {
      setAccordion1Checked(false);
      setAccordion2Checked(true);
    }
  }, [deliverorpayaddress]);

  const handleAccordion1Change = () => {
    setAccordion1Checked(true);
    setAccordion2Checked(false);
    store.dispatch(setSelectedDeliverorPayAddressData("delivery"));
  };

  const handleAccordion2Change = () => {
    setAccordion2Checked(true);
    setAccordion1Checked(false);
    store.dispatch(setSelectedDeliverorPayAddressData("payment"));
  };

  return (
    <div id="ips-billingaddress-checkout-details" className="ips-module">
      <div className="row g-3">
        <h4 className="mb-3">Rechnungsadresse</h4>
        <div>Wähle die Adresse aus, die deiner Karte oder Zahlungsmethode entspricht.</div>

        <div className="accordion" id="accordionBilling">
          <div className="accordion-item ips-checkout-item-color">
            <h2 className="accordion-header ips-checkout-header-color" id="panelsStayOpen-headingOne">
              <button
                className={`accordion-button ips-firstelement ${accordion1Checked ? '' : 'collapsed'}`}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#panelsStayOpen-collapseOne"
                aria-expanded={accordion1Checked}
                aria-controls="panelsStayOpen-collapseOne"
                onClick={handleAccordion1Change}
              >
                <div className="form-check mt-1">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="accordionOption"
                    id="accordionOption1"
                    checked={accordion1Checked}
                    readOnly
                  />
                </div>
                <div style={{ color: 'black', paddingLeft: '15px' }}>Entspricht Lieferadresse</div>
              </button>
            </h2>
            <div
              id="panelsStayOpen-collapseOne"
              className={`accordion-collapse collapse ${accordion1Checked ? 'show' : ''}`}
              aria-labelledby="panelsStayOpen-headingOne"
              data-bs-parent="#accordionBilling"
            >
              <div className="accordion-body ms-3">
                {/* Hier könntest du weitere Inhalte hinzufügen */}
              </div>
            </div>
          </div>
          <div className="accordion-item ips-checkout-item-color">
            <h2 className="accordion-header ips-checkout-header-color" id="panelsStayOpen-headingTwo">
              <button
                className={`accordion-button ips-secondelement ${accordion2Checked ? '' : 'collapsed'}`}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#panelsStayOpen-collapseTwo"
                aria-expanded={accordion2Checked}
                aria-controls="panelsStayOpen-collapseTwo"
                onClick={handleAccordion2Change}
              >
                <div className="form-check mt-1">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="accordionOption"
                    id="accordionOption2"
                    checked={accordion2Checked}
                    readOnly
                  />
                </div>
                <div style={{ color: 'black', paddingLeft: '15px' }}>Verwende eine andere Rechnungsadresse</div>
              </button>
            </h2>
            <div
              id="panelsStayOpen-collapseTwo"
              className={`accordion-collapse collapse ${accordion2Checked ? 'show' : ''}`}
              aria-labelledby="panelsStayOpen-headingTwo"
              data-bs-parent="#accordionBilling"
            >
              <div className="accordion-body ms-3">
                <BlockPayAddress store={store} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlockBilling;